<script>
import {useMenuStore} from "@js/store/MenuStore.js";
import {Link, router} from "@inertiajs/vue3";
import {onBeforeUnmount, ref, watch} from "vue";
import ImageLoader from "@js/components/Loaders/ImageLoader.vue";

export default {
    name: "TopBarCatalogDropdown",
    components: {ImageLoader, Link},
    methods: {
        buildMenuLink(item) {
            let url = this.route(item.route_name, {
                category_title: item.route_params.category_title,
            });

            if (item.route_params?.query) {
                const queryParams = new URLSearchParams();
                for (const [key, values] of Object.entries(item.route_params.query)) {
                    queryParams.append(key, JSON.stringify(values));
                }
                url += "?" + queryParams.toString();
            }
            return url;
        },
    },
    setup() {
        const menuStore = useMenuStore();
        const menuRef = ref(null);

        const handleClickOutside = (e) => {
            if (menuStore.isMenuCatalogOpen && menuRef.value && !menuRef.value.contains(e.target)) {
                menuStore.isMenuCatalogOpen = false;
            }
        };

        watch(
            () => menuStore.isMenuCatalogOpen,
            (isOpen) => {
                if (isOpen) {
                    setTimeout(() => document.addEventListener("click", handleClickOutside), 50);
                } else {
                    document.removeEventListener("click", handleClickOutside);
                }
            }
        );

        onBeforeUnmount(() => {
            document.removeEventListener("click", handleClickOutside);
            menuStore.isMenuCatalogOpen = false;
        });

        router.on("before", () => {
            menuStore.isMenuCatalogOpen = false;
        });

        return {menuStore, menuRef};
    },
};
</script>

<template>
    <nav v-show="menuStore.isMenuCatalogOpen" ref="menuRef"
        class="absolute z-10 inset-x-0 bg-white border-y border-gray-200 shadow-xs">
        <div class="container">
            <div class="py-4">
                <div class="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 2xl:columns-5">
                    <!-- группа категории -->
                    <div v-for="(cat, idx) in menuStore.menuItems"
                         :key="idx" class="mb-6 pr-6 break-avoid">
                        <Link :href="route(cat.route_name, cat.route_params || {})"
                              class="block text-sm font-medium text-gray-900 hover:text-navHoverColor transition">
                            <div class="flex items-center gap-3">
                                <img  alt="" aria-hidden="true" role="presentation"
                                     :src="`/storage/category_icons/${cat.route_params.category_title}.webp`"
                                     class="h-[35px] w-[35px] object-cover rounded object-bottom"/>
                                {{ cat.title }}
                            </div>
                        </Link>

                        <ul v-if="cat.sub_menu && cat.sub_menu.length" class="mt-2 space-y-1 ms-[48px]">
                            <li v-for="(sub, sIdx) in cat.sub_menu" :key="sIdx">
                                <Link :href="buildMenuLink(sub)"
                                      class="block text-sm text-gray-700 hover:text-navHoverColor transition">
                                    {{ sub.title }}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<style scoped>
.break-avoid {
    break-inside: avoid;
}
</style>
